<!-- Handle HTML convertion for List view  -->
<script lang="ts">
  interface Props {
    value?: string;
  }

  let { value = null }: Props = $props();
</script>

<div class="comp-markup-text-list-type">
  {@html value}
</div>

<style>
  .comp-markup-text-list-type :global(a) {
    text-decoration: none;
    color: var(--blue);
  }
</style>
